import script from "./SLCRedirectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SLCRedirectButton.vue?vue&type=script&setup=true&lang=ts"

import "./SLCRedirectButton.vue?vue&type=style&index=0&id=2d38405a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d38405a"]])

export default __exports__